import { Swiper } from 'swiper';
import 'swiper/css';

export default function () {
    if (document.querySelector('.logo-download__swiper')) {
        initSwiper();
    }
}

const initSwiper = () => {
    const swiper = new Swiper('.logo-download__swiper', {
        slidesPerView: 1.2,
        spaceBetween: 24,
        grabCursor: true,
        breakpoints: {
            440: {
                slidesPerView: 1.8,
            },
            768: {
                slidesPerView: 3.2,
                spaceBetween: 24,
            },
            1024: {
                grabCursor: false,
                enabled: false,
                slidesPerView: 4,
                spaceBetween: 0,
            },
        },
    });
};
